import { PERMISSIONS } from '@/composables/policies/permissions.ts';

export const adminMenuConfig = [
  {
    key: 'requests',
    label: 'Requests',
    items: [
      {
        label: 'Event Requests',
        route: { name: 'admin-event-forms-awaiting-review'},
        permission: PERMISSIONS.admin.eventForms.access,
        relatedRoutes: [
          'admin-event-forms-awaiting-review',
          'admin-event-forms-conditionally-approved',
          'admin-event-forms-approved',
          'admin-event-forms-rejected',
          'admin-event-forms-changes-requested',
          'admin-event-forms-archived',
          'admin-event-form-show',
          'admin-event-form-edit'
        ]
      },
      {
        label: 'Reimbursement Requests',
        permission: PERMISSIONS.admin.reimbursementRequests.access,
        route: { name: 'admin-club-reimbursement-requests-listing-pending' },
        relatedRoutes: [
          'admin-club-reimbursement-requests-listing-pending',
          'admin-club-reimbursement-requests-listing-on-hold',
          'admin-club-reimbursement-requests-listing-not-on-hold',
          'admin-club-reimbursement-requests-listing-approved-by-me',
          'admin-club-reimbursement-requests-show',
          'admin-club-reimbursement-requests-batches-listing',
          'admin-club-reimbursement-requests-batch',
          'admin-club-reimbursement-requests-edit'
        ],
      },
      {
        label: 'New Club Applications',
        permission: PERMISSIONS.admin.clubApplications.access,
        route: { name: 'admin-club-applications-pending' },
        relatedRoutes: [
          'admin-club-application-show',
          'admin-club-applications-rejected',
          'admin-club-applications-completed',
          'admin-club-applications-changes-requested'
        ],
      },
      {
        label: 'Club Profile Updates',
        permission: PERMISSIONS.admin.clubProfileRequests.access,
        route: { name: 'admin-club-profile-updates-listing-pending' },
        relatedRoutes: [
          'admin-club-profile-updates-listing-pending',
          'admin-club-profile-updates-listing-completed',
          'admin-club-profile-updates-listing-rejected',
          'admin-club-profile-update-show',
        ],
      },
      {
        label: 'Term Acknowledgement Forms',
        permission: [
          PERMISSIONS.admin.termAcknowledgementForms.view,
          PERMISSIONS.admin.termAcknowledgementForms.manage,
        ],
        route: { name: 'admin-term-acknowledgement-form-listing' },
        relatedRoutes: [
          'admin-term-acknowledgement-form-show',
        ],
      },
    ],
  },
  {
    key: 'clubs',
    label: 'Clubs',
    items: [
      {
        label: 'Clubs Listing',
        permission: PERMISSIONS.admin.clubs.view,
        route: { name: 'admin-clubs-listing-all' },
        relatedRoutes: [
          'admin-clubs-listing-all',
          'admin-clubs-listing-active',
          'admin-clubs-listing-inactive',
          'admin-clubs-listing-purged',
          'admin-clubs-show-overview',
          'admin-clubs-show-associated',
          'admin-clubs-show-transactions',
          'admin-clubs-show-members',
          'admin-clubs-show-term-history',
          'admin-club-profile-constitution',
          'admin-club-profile-edit',
        ],
      },
    ],
  },
  {
    key: 'events',
    label: 'Event Management',
    permission: null,
    icon: '',
    items: [
      {
        label: 'AV Catalogue',
        route: { name: 'admin-av-categories-listing-active' },
        permission: PERMISSIONS.admin.avEquipmentCategories.view,
        relatedRoutes: [
          'admin-av-categories-listing-active',
          'admin-av-categories-listing-inactive'
        ]
      },    
      {
        label: 'Bookable Locations',
        route: { name: 'admin-bookable-locations-listing-all' },
        permission: PERMISSIONS.admin.locations.manage,
        relatedRoutes: [
          'admin-bookable-locations-listing-all',
          'admin-bookable-locations-listing-enabled',
          'admin-bookable-locations-listing-disabled',
          'admin-bookable-locations-import',
        ]
      },       
      {
        label: 'Event Types',
        route: { name: 'admin-event-types-listing-active'},
        permission: PERMISSIONS.admin.eventTypes.view,
        relatedRoutes: [
          'admin-event-types-listing-active',
          'admin-event-types-listing-deleted'
        ]
      },
      {
        label: 'Risk Management',
        route: { name: 'admin-risk-management-dashboard' },
        permission: PERMISSIONS.admin.riskManagement.access,
        relatedRoutes: [
          'admin-risk-management-dashboard',
          'admin-risk-levels-listing',
          'admin-event-risk-conditions'
        ]
      },      
    ]
  },  
  {
    key: 'terms',
    label: 'Terms',
    items: [
      {
        label: 'Terms Listing',
        permission: PERMISSIONS.admin.terms.view,
        route: { name: 'admin-terms-listing' },
      },
    ],
  },
  {
    key: 'reports',
    label: 'Reports',
    items: [
      {
        label: 'Clubs Email',
        permission: PERMISSIONS.admin.clubEmails.view,
        route: { name: 'admin-clubs-emails-listing' },
      },
      {
        label: 'All Club Codes',
        permission: PERMISSIONS.admin.clubCodeReports.access,
        route: { name: 'admin-club-codes-listing' },
      },
      {
        label: 'Clubs Without Codes',
        permission: PERMISSIONS.admin.clubCodeReports.access,
        route: { name: 'admin-clubs-without-codes-listing' },
      },
      {
        label: 'Clubs Pending Purge',
        permission: PERMISSIONS.admin.clubsInactiveReports.access,
        route: { name: 'admin-inactive-clubs-listing' },
      },
    ],
  },
  {
    key: 'users',
    label: 'Users & Groups',
    items: [
      {
        label: 'Users',
        permission: PERMISSIONS.admin.users.viewUsers,
        route: { name: 'admin-users-listing' },
        relatedRoutes: [
          'admin-users-show',
          'admin-users-import',
        ],
      },
      {
        label: 'Groups',
        permission: PERMISSIONS.admin.groups.view,
        route: { name: 'admin-groups-listing' },
        relatedRoutes: [
          'admin-groups-show',
        ],
      },
      {
        label: 'Contact Lists',
        permission: PERMISSIONS.admin.contactLists.manage,
        route: { name: 'admin-contact-lists-listing' },
        relatedRoutes: [
          'admin-contact-lists-show',
        ],
      },
    ],
  },
  {
    key: 'formsettings',
    label: 'Forms',
    items: [
      {
        label: 'Forms',
        permission: PERMISSIONS.admin.forms.access,
        route: { name: 'admin-forms-listing' },
        relatedRoutes: [
          'admin-forms-listing',
          'admin-form',
          'admin-form-root',
          'admin-form-availability',
          'admin-form-manage-permissions'
        ]
      },
    ],
  },  
  {
    key: 'settings',
    label: 'Settings',
    items: [
      {
        label: 'Organization Settings',
        permission: PERMISSIONS.admin.organizations.view,
        route: { name: 'admin-organizations' },
        relatedRoutes: [],
      },
      {
        label: 'Categories',
        permission: PERMISSIONS.admin.categories.view,
        route: { name: 'admin-categories-listing' },
      },
      {
        label: 'Announcements',
        permission: PERMISSIONS.admin.announcements.view,
        route: { name: 'admin-announcements-listing' },
        relatedRoutes: [
          'admin-announcements-listing',
          'admin-announcements-new',
          'admin-announcements-edit',
        ],
      },
      {
        label: 'Email Templates',
        permission: [PERMISSIONS.admin.emailTemplates.access, PERMISSIONS.admin.emailTemplates.manageAll],
        route: { name: 'admin-email-templates-listing' },
        relatedRoutes: [
          'admin-email-templates-listing',
          'admin-email-templates-new',
          'admin-email-templates-edit',
        ],
      },
      {
        label: 'Application Settings',
        permission: PERMISSIONS.admin.settings.manage,
        route: { name: 'admin-settings-edit' },
      },
      {
        label: 'FAQ',
        permission: PERMISSIONS.admin.faqs.view,
        route: { name: 'admin-faq-listing' },
        relatedRoutes: [
          'admin-faq-new-section',
          'admin-faq-edit-section',
          'admin-faq-show-section',
          'admin-faq-new-question',
          'admin-faq-edit-question',
        ],
      },
      {
        label: 'Resources',
        permission: PERMISSIONS.admin.resources.access,
        route: { name: 'admin-resources-listing' },
      },
      {
        label: 'System Monitoring',
        permission: PERMISSIONS.admin.systemMonitoring.show,
        route: { name: 'admin-system-monitoring' },
        relatedRoutes: [
          'admin-system-monitoring',
          'admin-email-logs-listing',
          'admin-email-logs-show',
        ],
      },
    ],
  }
];
